var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8h24l10 10v38H16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8v12h12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30h16M24 39h16M24 48h10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 42l7 7 8-14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c8b646267d3a2b6158669cbed9bf4c13.svg";
export { ForwardRef as ReactComponent };